export enum AssignmentSequence {
  CONTINUE = "CONTINUE", // CONTINUE THROUGH TO NEXT ACTIVITY (DEFAULT)
  BREAK = "BREAK", // ACTIVITY THAT BREAKS OUT BACK TO MENU
}
